import { useTheme } from 'styled-components';

export const WarningIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.23855 0.333272C6.98418 -0.111091 6.34918 -0.111091 6.09481 0.333272L0.0892414 11C-0.164501 11.4444 0.152991 12 0.661734 12H12.6716C13.1803 12 13.4978 11.4444 13.2441 11L7.23855 0.333272ZM6.66668 4.0001C7.0348 4.0001 7.33356 4.29885 7.33356 4.66698V8.00005C7.33356 8.36817 7.0348 8.66692 6.66668 8.66692C6.29855 8.66692 5.9998 8.36817 5.9998 8.00005V4.66698C5.9998 4.29885 6.29855 4.0001 6.66668 4.0001ZM7.33356 10C7.33356 10.3681 7.0348 10.6669 6.66668 10.6669C6.29855 10.6669 5.9998 10.3681 5.9998 10C5.9998 9.6319 6.29855 9.33315 6.66668 9.33315C7.0348 9.33315 7.33356 9.6319 7.33356 10Z"
        fill={theme.redNotification}
      />
    </svg>
  );
};
